// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"398f38c9","105":"47bc9a58","535":"000afe45"}[chunkId] + ".chunk.js";
};